import {
  type AiVideoCamera,
  fetchAiVideoCameras,
  fetchAiVideoIds,
  generatePreviewStreamUrl,
  generateStreamUrl,
} from '../queries/ai-video.queries'

import { useQuery } from '@tanstack/react-query'

export type { AiVideoCamera } from '../queries/ai-video.queries'

export const useVideoIds = (storeId: number) =>
  useQuery<string[], Error>({
    queryKey: ['videoIds', storeId],
    queryFn: () => fetchAiVideoIds(storeId),
    refetchOnWindowFocus: false,
  })

export const useVideoCameras = (storeId: number) =>
  useQuery<AiVideoCamera[], Error>({
    queryKey: ['videoCameras', storeId],
    queryFn: () => fetchAiVideoCameras(storeId),
    refetchOnWindowFocus: false,
  })

export const useAiVideoUrl = (storeId?: number, videoId?: string | null) =>
  useQuery<string | undefined, Error>({
    queryKey: ['ai-video-url', storeId, videoId],
    queryFn: () => generateStreamUrl(storeId, videoId ?? ''),
  })

export const useAiPreviewVideoUrl = (storeId: number | null, videoId: string | null) =>
  useQuery<string | null, Error>({
    queryKey: ['ai-video-preview-url', storeId, videoId],
    queryFn: () => generatePreviewStreamUrl(storeId, videoId ?? ''),
  })
